import { ThemeProvider } from 'styled-components';
import { DarkTheme } from '../../styles/themes';
import { IconButton } from '../Button';
import { Box } from '../Core';
import { FormControlSizes } from '../Form';
import { Icon, IconName } from '../Icons';
import { useNotes } from './NotesProvider';
import { NoteContent, NoteWrapper, Square, Squares } from './styles';
import { NoteVariant, type NoteProps } from './types';

export function Note(props: NoteProps) {
  const { removeNote } = useNotes();
  const note = (
    <NoteWrapper variant={props.variant}>
      {(props.variant === NoteVariant.Announcement || props.variant === NoteVariant.Primary) && (
        <Squares>
          <Square />
          <Square />
          <Square />
          <Square />
          <Square />
          <div />
          <Square />
          <div />
          <div />
          <div />
          <Square />
          <div />
          <Square />
        </Squares>
      )}
      <NoteContent>
        {props.icon && <Icon icon={props.icon} />}
        <div>{props.text}</div>
      </NoteContent>
      <Box gap="spacing4" display="flex" alignItems="center">
        {props.actions}
        {props.closable && (
          <IconButton
            size={FormControlSizes.Small}
            icon={IconName.Close}
            onClick={() => removeNote(props.id, props.closable, props.storage)}
            ghost
          />
        )}
      </Box>
    </NoteWrapper>
  );

  // Pinned to DarkTheme so every variant looks the same regardless of the app's theme.
  return <ThemeProvider theme={DarkTheme}>{note}</ThemeProvider>;
}
